import { ref, computed, onMounted, onUnmounted } from 'vue'

/**
 * 屏幕尺寸检测 Composable
 * 提供响应式的屏幕宽度检测和断点判断
 * @param breakpoint 断点值，默认 480px
 * @returns 屏幕尺寸相关的响应式状态
 */
export function useScreenSize(breakpoint: number = 480) {
  const screenWidth = ref(window.innerWidth)

  // 监听窗口大小变化
  const handleResize = () => {
    screenWidth.value = window.innerWidth
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  // 判断是否小于断点
  const isSmallScreen = computed(() => screenWidth.value < breakpoint)

  // 判断是否大于等于断点
  const isLargeScreen = computed(() => screenWidth.value >= breakpoint)

  return {
    screenWidth,
    isSmallScreen,
    isLargeScreen,
  }
}
